import React, { PureComponent } from 'react'
import { func, bool } from 'prop-types'
import Modal from '@active/react-ui/Modal'
import Button from '@active/react-ui/Button'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import { Locale, withI18n } from '@active/react-utils/i18n'

import CardNumberInfo from '../CardNumberInfo'
import paymentMethodTypes, { paymentMethodPropType } from '../paymentMethodTypes'

import './PaymentMethodDelPopup.scss'

class PaymentMethodDelPopup extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,

    isShow: bool.isRequired,
    handleDeletePaymentMethod: func.isRequired,
    handlePaymentDelPopupCancel: func.isRequired,
    i18n: func.isRequired,
  }

  triggerDelete = () => {
    const { paymentMethod, handleDeletePaymentMethod } = this.props
    handleDeletePaymentMethod(paymentMethod)
  }

  render() {
    const {
      paymentMethod, isShow, handlePaymentDelPopupCancel, i18n,
    } = this.props
    const info = paymentMethodTypes.convert(paymentMethod)
    const [cardName, cardClassName] = info.getCardName()

    return (
      <div className="checkout-payments checkout__payment-del-popup">
        <Modal
          autoFocusClose
          shown={isShow}
          onClose={handlePaymentDelPopupCancel}
          title={i18n('passport.lib.components.payment.delete.title')}
        >
          <ModalBody>
            <div className="checkout__payment-del-popup--subtitle">
              <Locale id="passport.lib.components.payment.delete.subtitle" />
            </div>
            <div className="checkout__payment-del-popup--name">
              <span className={`checkout__payment-del-popup--name-${cardClassName}`}>{cardName}</span>
            </div>
            <CardNumberInfo paymentMethod={info} />
          </ModalBody>
          <ModalFooter>
            <Button className="btn-primary" onClick={this.triggerDelete}>
              <Locale id="passport.lib.components.common.btn.delete" />
            </Button>
            <Button className="btn-blue" onClick={handlePaymentDelPopupCancel}>
              <Locale id="passport.lib.components.common.btn.cancel" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default withI18n(PaymentMethodDelPopup)
